<template>
  <div style="width: 100%">
    <v-data-table
        :headers="headers"
        :items="items"
        :hide-default-header="items.length === 0"
        :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        hide-default-footer dense
        disable-pagination
        style="white-space: nowrap">
      <template v-slot:top>
        <v-toolbar flat dense>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn @click="row_create" small class="ma-2" color="primary">ADD</v-btn>
          <v-spacer/>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small>mdi-content-copy</v-icon>
        <v-icon @click="row_moveup(item)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
        <v-icon @click="row_movedown(item)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <r-worker-dialog ref="dialog"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {WorkerKey} from "@/modules/redactor/models/worker/WorkerKey";
import RWorkerDialog from "@/modules/redactor/views/worker/r-worker-dialog";

export default {
  name: "r-worker-table",
  components: {RWorkerDialog},
  props: {
    items: VueTypes.arrayOf(WorkerKey),
    title: VueTypes.string.def("Workers")
  },
  data: () => ({
    headers: [
      {text: 'Name', value: 'kind.name'},
      {text: 'Level', value: 'level'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  methods: {
    row_copy(item) {
      this.items.push(item.copy());
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
          .then((data) => {
            if (!this.items.some(v => v.equal(data))) {
              this.items.push(data);
            } else {
              this.$alert("Duplicate!");
            }
          }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone())
          .then((data) => {
            if (item.equal(data)) {
              //nothing
            } else if (!this.items.some(v => v.equal(data))) {
              const index = this.items.indexOf(item);
              this.items.splice(index, 1, data);
            } else {
              this.$alert("Duplicate!");
            }
          }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      });
    },
    row_moveup(item) {
      const index = this.items.indexOf(item);
      if (index > 0) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },
    row_movedown(item) {
      const index = this.items.indexOf(item);
      if (index < this.items.length - 1) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    }
  }
}

</script>